import { html } from "lit-html"
import type { SYSTableDefIds } from "../../../../.."
import { T } from "../../../../../textapi"
import type { DialogHolderParams } from "../../../../dialog/dialogapi"
import { DialogIsOpen, DialogClose } from "../../../../dialog/dialogapi"
import { SYSBaseElement } from "../../../../sysbaseelement"
import type { NavDef } from "../../../navcontrol"
import {
  _GetFilterSettingsCardCodes,
  _GetFilterSettingsCntctCodes,
} from "../helpers"

export class SYSTableSettingsFilterSortDialog extends SYSBaseElement {
  instance: any
  async init() {
    this.dialog = "SYSTableSettings_FilterSort"
    this.instance = DialogIsOpen("SYSTableHeaderMenu", "1") ? "2" : "1"
    await _GetFilterSettingsCardCodes()
    await _GetFilterSettingsCntctCodes()
    await super.init()
  }
  async getUI() {
    let tableId = "SYSTableSettings_FilterSort"
    let dialogHolderParams: DialogHolderParams
    dialogHolderParams = {
      dialogParts: {
        dismissedCallbackFn: () => {
          DialogClose(this.dialog, { instance: this.dialogInstance })
        },
        title: () => T("SYSTableSettingsFilterSortSettings"),
        body: () => html`<ovl-table
          class="fd-table fd-table--no-horizontal-borders"
          .props=${() => tableId}
        >
        </ovl-table>`,
        footer: () => html` <ovl-tnavcontrol
          .props=${() => {
            return {
              defId: tableId,
            } as NavDef
          }}
        ></ovl-tnavcontrol>`,
      },
      dialogType: this.dialog,
    }
    return html`<ovl-dialogholder
      .dialogHolderParams=${dialogHolderParams}
    ></ovl-dialogholder>`
  }
}
